export default "__VITE_ASSET__BzngbTwC__"